// extracted by mini-css-extract-plugin
module.exports = {"container":"Content_container__1LbX_"};